import { useState } from 'preact/hooks'
import { addCartItem, getCart, addMultipleCartItems } from 'libs/cart'
import { isEmpty } from 'helpers/utils'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import ButtonATC from 'snippets/button-atc/button-atc'
import WishlistButton from 'snippets/wishlist/wishlist-button/wishlist-button'
import Price from 'snippets/price/price'

function ProductBundleFormATC({
  isStickyATC,
  initProduct,
  currentVariant,
  bundles,
  minItemsRequired,
  isBundleFixed,
  sellingPlanId,
  currentVariantPrice,
  isDisabledATC,
  currentSellingPlan,
  isMobile
}) {
  const bundleList = bundles ? Object.values(bundles) : []
  const [isAdding, setIsAdding] = useState(false)

  const getSellingPlanId = (product) => {
    const sellingPlan = product.selling_plan_groups.find((plan) => plan.options[1]?.values[0] === currentSellingPlan)

    if (!sellingPlan) return null

    const allocationId = product.variants[0].selling_plan_allocations.find(
      (item) => item.selling_plan_group_id === sellingPlan.id
    )?.selling_plan_id

    return allocationId || null
  }

  const addToCart = async () => {
    const bundle = {
      externalVariantId: currentVariant.id,
      externalProductId: initProduct.id,
      selections: bundleList.map((item) => ({
        collectionId: item.id,
        externalProductId: item.product.id,
        externalVariantId: item.product.variants[0].id,
        quantity: 1,
        ...(!isBundleFixed && sellingPlanId && { sellingPlan: getSellingPlanId(item.product) })
      }))
    }

    try {
      let response

      setIsAdding(true)

      if (isBundleFixed) {
        const rbId = await window.recharge.bundle.getBundleId(bundle)
        const properties = {
          _rb_id: rbId,
          _rb_list_bundle: bundleList.map((item) => `${item.product.title} ${item.product.type}`),
          _isBundle: true
        }

        response = await addCartItem(currentVariant.id, properties, 1, sellingPlanId)
      } else {
        const cartItems = await window.recharge.bundle.getDynamicBundleItems(bundle, initProduct.handle)

        const cartItemsWithBundleFlag = cartItems.map((item) => ({
          ...item,
          properties: {
            ...(item.properties || {}),
            _isBundle: true
          }
        }))

        response = await addMultipleCartItems({ items: cartItemsWithBundleFlag })
      }

      if (!response) throw new Error('Can not add to cart')

      const newCart = await getCart()

      globalEmitter.emit(emitterProps.cart.add, newCart)
    } catch (error) {
      console.error(error)
    } finally {
      setIsAdding(false)
    }
  }

  if (bundleList.length === minItemsRequired) {
    return (
      <div className={isStickyATC ? '' : 'mt-6 flex'}>
        <ButtonATC
          text={isMobile && isStickyATC ? translate.general.add : translate.general.addToCart}
          onHandle={addToCart}
          price={currentVariantPrice}
          loading={isAdding}
          buttonClass={`button-primary ${isStickyATC ? 'w-fit min-w-[180px] md-max:min-w-[135px] md-max:px-2' : 'pl-4 text-left'}`}
          disabled={isDisabledATC}
          hiddenPrice={!isStickyATC}
        />
        {!isStickyATC ? (
          <WishlistButton
            className="button-add-wishlist min-h-[46px] shrink-0 border border-neutral-900 px-6 text-neutral-700 disabled:text-neutral-300"
            product={initProduct}
            variantSelected={currentVariant?.id}
            isProductForm
            disabled={isEmpty(currentVariant) || isDisabledATC}
            classIcon="size-4"
          />
        ) : null}
      </div>
    )
  }

  return (
    <div className={isStickyATC ? 'shrink-0' : 'mt-6 flex gap-px'}>
      <button
        type="button"
        className={`button-disabled min-h-[46px] w-full pt-0.5 text-left text-xs uppercase ${isStickyATC ? 'px-6 md-max:px-2.5' : 'pl-4'}`}
      >
        {isMobile ? translate.general.add : translate.general.addToCart}
        {isStickyATC ? (
          <>
            {' - '}
            <Price className="inline text-xs" price={currentVariantPrice} />
          </>
        ) : null}
      </button>
      {!isStickyATC ? (
        <WishlistButton
          className="button-add-wishlist min-h-[46px] shrink-0 px-6 disabled:bg-neutral-100 disabled:text-neutral-400"
          product={initProduct}
          variantSelected={currentVariant?.id}
          isProductForm
          disabled
          classIcon="size-4"
        />
      ) : null}
    </div>
  )
}

export default ProductBundleFormATC
